export const COLORS = {
  teal: '#1b8f9b',
  tealMid: '#3aacb8',
  red: '#e05252',
  amber: '#c47f17',
  lime: '#bdc432',
  ink: '#1a2a2b',
  label: '#7a9496',
  border: 'rgba(0,0,0,0.07)',
};
